// extracted by mini-css-extract-plugin
export default {"container":"customFooter_container__irCyu"};